import { ReactNode, useContext } from 'react';
import { ConfigContext } from 'src/configContext.ts';
import { Price } from 'src/common/Price/Price';
import { SelectionDataContext } from 'src/projects/components/SelectionDataContext.ts';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';
import { SkeletonPrice } from 'src/projects/components/SkeletonPrice.tsx';

export const SelectionSubtotal = ({ withTitle }: { withTitle: boolean }) => {
    const { userSettings } = useContext(ConfigContext);
    const ctx = useContext(SelectionDataContext);

    if (ctx === null || userSettings.shoppingCenter === null) {
        return null;
    }

    // A dash is for "there is no price", not for "the price is on its way" — while the query is
    // still queued or running the slot shows a placeholder instead.
    let value: ReactNode = '—';
    if (ctx.loading) {
        value = <SkeletonPrice size="lg"/>;
    } else if (ctx.total !== null) {
        value = (
            <Price
                price={ctx.total}
                currency={ctx.currency}
                locale={userSettings.currentLocale}
            />
        );
    }

    if (withTitle) {
        return (
            <div className="vss-project-selection-item__subtotal">
                <span className="vss-project-selection-item__subtotal-label">
                    <I18n messageId={MESSAGES.checkoutSubTotal}/>
                </span>

                <span className="vss-project-selection-item__subtotal-value">
                    {value}
                </span>
            </div>
        );
    }
    return value;
};
